import { useState, useRef, useEffect, useContext } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { AuthContext } from "../../../context/AuthContext";
import { useCart } from "../../../context/CartContext";

import MainButton from "../MainButton/MainButton";
import SecondButton from "../../Elements/SecondButton/SecondButton";
import LogoIcon from "../../../assets/logo.png";
import cartIcon from "../../../assets/cart/cart-primary.png";
import cartGray from "../../../assets/cart/cart-gray.png";
import arrowImg from "../../../assets/data/sort_down.png";
import arrowDown from "../../../assets/data/sort_down.png";

import "./Header.css";

const NavigationHeader = () => {
  const navigate = useNavigate();
  const { token, setToken, role } = useContext(AuthContext);
  const profileRef = useRef(null);
  const { itemCount } = useCart();

  // State controlling mobile menu and dropdowns visibility
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileAdminOpen, setMobileAdminOpen] = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);
  const [adminOpen, setAdminOpen] = useState(false);

  // Refs for dropdown elements to manage outside clicks
  const adminRef = useRef(null);
  const statsRef = useRef(null);

  const handleSignOut = () => {
    setToken(null);
    localStorage.removeItem("token");
    navigate("/sign-in");
  };

  useEffect(() => {
    const handleClick = (e) => {
      if (window.innerWidth < 1050) return;

      const profileEl = profileRef.current;
      const adminEl = adminRef.current;

      if (!profileEl || !adminEl) return;

      if (profileEl && !profileEl.contains(e.target)) {
        setProfileOpen(false);
      }

      if (adminEl && !adminEl.contains(e.target)) {
        setAdminOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClick, true);

    return () => {
      document.removeEventListener("mousedown", handleClick, true);
    };
  }, []);

  // if (loading) return <div>Loading...</div>;

  return (
    <>
      {/* Main navigation header */}
      <nav className="header">
        <div className="header-left">
          {/* Hamburger menu for mobile */}
          <button className="hamburger" onClick={() => setMobileOpen(true)} aria-label="Open menu">
            <span />
            <span />
            <span />
          </button>

          {/* Logo section with icon and title */}
          <div className="header-logo" onClick={() => navigate("/")}>
            <img src={LogoIcon} alt="Logo" className="logo-icon" />
            <span className="header-title">Telviora</span>
          </div>
        </div>

        {/* Desktop navigation links */}
        {/* Desktop navigation links */}
        <div className="header-links">
          <NavLink to="/" className="nav-item">
            Home
          </NavLink>
          <NavLink to="/shop" className="nav-item">
            Buy eSIM
          </NavLink>

          {token && (
            <div className="header-dropdown" ref={profileRef}>
              <button onClick={() => setProfileOpen((prev) => !prev)}>
                Profile <img src={arrowImg} className={`header-dropdown-arrow ${profileOpen ? "open" : ""}`} />
              </button>
              {profileOpen && (
                <div className="dropdown-menu">
                  <NavLink to="/account" onClick={() => setProfileOpen(false)}>
                    Account
                  </NavLink>
                  <NavLink to="/affiliation" onClick={() => setProfileOpen(false)}>
                    Affiliation
                  </NavLink>
                </div>
              )}
            </div>
          )}

          {token && (
            <NavLink to="esim" className="nav-item">
              My eSIMs
            </NavLink>
          )}

          <NavLink to="/faq" className="nav-item">
            FAQ
          </NavLink>

          <NavLink to="/contact" className="nav-item">
            Contact
          </NavLink>

          {token && role?.name === "admin" && (
            <div className="header-dropdown" ref={adminRef}>
              <button onClick={() => setAdminOpen((v) => !v)}>
                <span>Admin</span>
                <img src={arrowDown} alt="" className={`header-dropdown-arrow ${adminOpen ? "open" : ""}`} />
              </button>
              {adminOpen && (
                <div className="dropdown-menu">
                  <NavLink to="/admin/users" onClick={() => setAdminOpen(false)}>
                    Users
                  </NavLink>

                  <NavLink to="/admin/wallets" onClick={() => setAdminOpen(false)}>
                    Wallets
                  </NavLink>

                  <NavLink to="/admin/transactions" onClick={() => setAdminOpen(false)}>
                    Transactions
                  </NavLink>

                  <NavLink to="/admin/promocodes" onClick={() => setAdminOpen(false)}>
                    Promocodes
                  </NavLink>

                  <NavLink to="/admin/notifications" onClick={() => setAdminOpen(false)}>
                    Notifications
                  </NavLink>

                  <NavLink to="/admin/support-chats" onClick={() => setAdminOpen(false)}>
                    Support Chats
                  </NavLink>

                  <NavLink to="/partner-offer" onClick={() => setAdminOpen(false)}>
                    Partner Offer
                  </NavLink>

                  <NavLink to="/admin/esim" onClick={() => setAdminOpen(false)}>
                    Esim Stats
                  </NavLink>

                  <NavLink to="/config" onClick={() => setAdminOpen(false)}>
                    Config
                  </NavLink>
                </div>
              )}
            </div>
          )}

          <NavLink to="/cart" className="header-cart-link" aria-label="Open cart" title="Open cart">
            <span className="header-cart-icon-wrap">
              <img src={itemCount > 0 ? cartIcon : cartGray} alt="" className="header-cart-icon" aria-hidden="true" />
              {itemCount > 0 && (
                <span className="header-cart-badge" aria-hidden="true">
                  {itemCount}
                </span>
              )}
            </span>
          </NavLink>

          {token ? (
            <MainButton className="btn btn-primary" onClick={handleSignOut}>
              Sign Out
            </MainButton>
          ) : (
            <div className="auth-buttons">
              <SecondButton
                onClick={() =>
                  navigate("/register", {
                    state: {
                      resetForgotPassword: true,
                    },
                  })
                }
              >
                Register
              </SecondButton>
              <MainButton
                className="btn btn-primary"
                onClick={() =>
                  navigate("/sign-in", {
                    state: {
                      resetForgotPassword: true,
                    },
                  })
                }
              >
                Sign In
              </MainButton>
            </div>
          )}
        </div>
      </nav>

      {/* Mobile side navigation panel */}
      {mobileOpen && <div className="menu-overlay" onClick={() => setMobileOpen(false)} aria-hidden="true" />}
      <div className={`sidenav ${mobileOpen ? "open" : ""}`}>
        <button className="close-btn" onClick={() => setMobileOpen(false)}>
          &times;
        </button>

        <NavLink to="/" onClick={() => setMobileOpen(false)}>
          Home
        </NavLink>

        <NavLink to="/shop" onClick={() => setMobileOpen(false)}>
          Buy eSIM
        </NavLink>

        <NavLink to="/faq" onClick={() => setMobileOpen(false)}>
          FAQ
        </NavLink>

        {token && (
          <>
            <NavLink to="/account" onClick={() => setMobileOpen(false)}>
              Account
            </NavLink>
            <NavLink to="/affiliation" onClick={() => setMobileOpen(false)}>
              Affiliation Program
            </NavLink>
            <NavLink to="/esim" onClick={() => setMobileOpen(false)}>
              My eSIMs
            </NavLink>
          </>
        )}
        <NavLink to="/contact" onClick={() => setMobileOpen(false)}>
          Contact
        </NavLink>

        <NavLink
          to="/cart"
          onClick={() => setMobileOpen(false)}
          className="header-cart-link"
          aria-label="Open cart"
          title="Open cart"
        >
          <span className="header-cart-icon-wrap">
            <img src={itemCount > 0 ? cartIcon : cartGray} alt="" className="header-cart-icon" aria-hidden="true" />
            {itemCount > 0 && (
              <span className="header-cart-badge" aria-hidden="true">
                {itemCount}
              </span>
            )}
          </span>
        </NavLink>

        {token && role?.name === "admin" && (
          <div className="sidenav-admin-section">
            {/* <div className="sidenav-admin-title">Admin</div> */}

            <NavLink to="/admin/users" onClick={() => setMobileOpen(false)}>
              Users
            </NavLink>

            <NavLink to="/admin/wallets" onClick={() => setMobileOpen(false)}>
              Wallets
            </NavLink>

            <NavLink to="/admin/transactions" onClick={() => setMobileOpen(false)}>
              Transactions
            </NavLink>

            <NavLink to="/admin/promocodes" onClick={() => setMobileOpen(false)}>
              Promocodes
            </NavLink>

            <NavLink to="/admin/notifications" onClick={() => setMobileOpen(false)}>
              Notifications
            </NavLink>

            <NavLink to="/admin/support-chats" onClick={() => setMobileOpen(false)}>
              Support Chats
            </NavLink>

            <NavLink to="/partner-offer" onClick={() => setMobileOpen(false)}>
              Partner Offer
            </NavLink>

            <NavLink to="/admin/esim" onClick={() => setMobileOpen(false)}>
              Esim Stats
            </NavLink>

            <NavLink to="/config" onClick={() => setMobileOpen(false)}>
              Config
            </NavLink>
          </div>
        )}

        {token ? (
          <MainButton className="btn btn-primary sidenav-btn" onClick={handleSignOut}>
            Sign Out
          </MainButton>
        ) : (
          <div className="sidenav-auth-buttons">
            <div
              onClick={() => {
                setMobileOpen(false);
                navigate("/register", {
                  state: {
                    resetForgotPassword: true,
                  },
                });
              }}
              className="sidenav-btn-link"
            >
              <MainButton className="btn btn-primary sidenav-btn">Register</MainButton>
            </div>
            <div
              onClick={() => {
                setMobileOpen(false);
                navigate("/sign-in", {
                  state: {
                    resetForgotPassword: true,
                  },
                });
              }}
              className="sidenav-btn-link"
            >
              <MainButton className="btn btn-primary sidenav-btn">Sign In</MainButton>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default NavigationHeader;
